import CreateAccountReducer from "@affinity/Store/AffinityCreateAccountReducer";
import CreateAccountState from "@affinity/Store/AffinityCreateAccountState";
import GetQuoteReducer from "@affinity/Store/AffinityGetQuoteReducer";
import GetQuoteState from "@affinity/Store/AffinityGetQuoteState";
import PlaceOrderReducer from "@affinity/Store/AffinityPlaceOrderReducer";
import PlaceOrderState from "@affinity/Store/AffinityPlaceOrderState";
import StripePaymentReducer from "@affinity/Store/AffinityStripePaymentReducer";
import StripePaymentState from "@affinity/Store/AffinityStripePaymentState";
import MyAccountReducer from "@affinity/Store/MyAccountReducer";
import MyAccountState from "@affinity/Store/MyAccountState";
import QueryStringReducer from "@affinity/Store/AffinityQueryStringReducer";
import QueryStringState from "@affinity/Store/AffinityQueryStringState";
import ServerSideRenderingReducer from "@affinity/Store/AffinityServerSideRenderingReducer";
import ServerSideRenderingState from "@affinity/Store/AffinityServerSideRenderingState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

(reducers as any).affinity_place_order = PlaceOrderReducer;
(reducers as any).affinity_get_quote = GetQuoteReducer;
(reducers as any).affinity_create_account = CreateAccountReducer;
(reducers as any).affinity_my_account = MyAccountReducer;
(reducers as any).affinity_stripe_payment = StripePaymentReducer;
(reducers as any).affinity_query_string = QueryStringReducer;
(reducers as any).affinity_server_side_rendering = ServerSideRenderingReducer;

export interface CustomState extends ApplicationState {
    readonly affinity_place_order: PlaceOrderState;
    readonly affinity_get_quote: GetQuoteState;
    readonly affinity_create_account: CreateAccountState;
    readonly affinity_my_account: MyAccountState;
    readonly affinity_stripe_payment: StripePaymentState;
    readonly affinity_query_string: QueryStringState;
    readonly affinity_server_side_rendering: ServerSideRenderingState;
}

type Reducers = {
    affinity_place_order: typeof PlaceOrderReducer;
    affinity_get_quote: typeof GetQuoteReducer;
    affinity_create_account: typeof CreateAccountReducer;
    affinity_my_account: typeof MyAccountReducer;
    affinity_stripe_payment: typeof StripePaymentReducer;
    affinity_query_string: typeof QueryStringReducer;
    affinity_server_side_rendering: typeof ServerSideRenderingReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;